import React from "react";
import ExlyTable from "common/Components/ExlyTable";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { getTransactionsTabConfig } from "features/Crm/modules/Transactions/utils/Transactions.utils";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import AddCustomerModal from "features/Crm/modules/AddCustomerModal/components/AddCustomerModal";
import { useQrPayments } from "./hooks/useQrPayments";
import {
  getTableConfig,
  filterConfig,
  tableChipsFormatter,
} from "./constants/qrPaymentsTableConfig";
import {
  EMPTY_STATE_PROPS,
  QR_PAYMENTS,
  QR_PAYMENTS_TABLE_TITLE,
  ADD_CUSTOMER_MODAL_KEY_PREFIX,
} from "./constants/qrPayments.constants";
import { FilteredEmptyState } from "../AllTransaction/components/TableFields/TableFields";
import { exportLargeListingData } from "utils/Utils";
import { REPORT_TYPES } from "ui/pages/Reports/constants";
import { useNotifications } from "utils/hooks";
import QrActions from "./components/QrActions/QrActions";
import { getQrOrderUuid } from "./utils/qrPayments.utils";

export const QrPayments = (props) => {
  const isWalletActive = useWalletStore((state) => state.isWalletActive);
  const { notify } = useNotifications();
  const {
    isAddCustomerOpen,
    selectedRecord,
    handleAddCustomer,
    handleCloseModal,
    handleSendThankYouLink,
    handleAttachCustomerSubmit,
    listingData,
    isLinkLoading,
  } = useQrPayments();

  // Render modal only when record is selected and (if dynamic link exists) its listing data is fully loaded
  const isModalReady =
    isAddCustomerOpen &&
    selectedRecord &&
    (!selectedRecord.dynamic_link_id || (!isLinkLoading && listingData));

  const renderQrAction = (record) => (
    <QrActions
      record={record}
      onAddCustomer={handleAddCustomer}
      onSendThankYouLink={handleSendThankYouLink}
    />
  );

  const modalKey = selectedRecord
    ? getQrOrderUuid(selectedRecord) || selectedRecord.id
    : ADD_CUSTOMER_MODAL_KEY_PREFIX;

  return (
    <div className="component-wrapper">
      <ExlyTable
        ra_props={{
          ...props,
        }}
        tableTitle={QR_PAYMENTS_TABLE_TITLE}
        tabConfig={getTransactionsTabConfig({ isWalletActive })}
        selectedTab={QR_PAYMENTS}
        columnConfig={getTableConfig}
        tableFilters={filterConfig()}
        tableChipsFormatter={tableChipsFormatter()}
        customHandleExport={({ filterValues, isEmpty }) =>
          exportLargeListingData({
            filterValues,
            reportType: REPORT_TYPES.QR_PAYMENTS,
            notify,
            isEmpty,
          })
        }
        layoutProps={{
          paddingDesktop: "0",
          paddingMobile: "0",
          paddingBottom: "68px",
          noMobileBoxShadow: true,
          showFixedBars: true,
        }}
        customPrimaryAction={{
          renderCustomAction: renderQrAction,
        }}
        desktopCustomPrimaryAction={{
          renderCustomAction: renderQrAction,
        }}
        primaryColumnProps={{
          align: "center",
          sticky: true,
          width: "90px",
        }}
        borderedFields
        fieldsLeftPadded
        drawerFieldsBordered
        fieldsAlignment="space-between"
        drawerFieldsAlignment="space-between"
        recordFooterVariant="secondary"
        filteredEmptyState={<FilteredEmptyState />}
        primaryKey="id"
        {...EMPTY_STATE_PROPS}
      />

      {isModalReady && (
        <AddCustomerModal
          key={modalKey}
          open={isModalReady}
          onClose={handleCloseModal}
          onSubmit={handleAttachCustomerSubmit}
          title="Add in customer details"
          primaryBtnText="Add Details"
          disableOffering={Boolean(selectedRecord?.dynamic_link_id)}
          disableAmount={true}
          listing_data={listingData}
          initialValues={{
            full_name:
              selectedRecord?.customer_full_name ||
              selectedRecord?.customer_name ||
              "",
            email: selectedRecord?.customer_email || "",
            customer_phone_number: selectedRecord?.customer_phone || "",
            phone: selectedRecord?.customer_phone || "",
            selected_price: selectedRecord?.amount || "",
            amount: selectedRecord?.amount || "",
            currency: selectedRecord?.currency || "INR",
          }}
        />
      )}
    </div>
  );
};

export default withComponentLibraryTheme(QrPayments);
